import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import styles from "./Business.module.css"
import Model from '../../model/Model'
import GlobalStorage from '../../../Storage/ContextProvider'
export function useOnScreen(ref) {

  const [isIntersecting, setIntersecting] = useState(false)


  const observer = useMemo(() => new IntersectionObserver(
    ([entry]) => setIntersecting(entry.isIntersecting)
  ), [ref])


  useEffect(() => {
    observer.observe(ref.current)
    return () => observer.disconnect()
  }, [])
  // //console.log(isInters ecting);
  return isIntersecting
}
function Business() {
  const {showModel, setShowModel,which, setWhich} = useContext(GlobalStorage)
  const refb = useRef()
  const isVisibleBusiness = useOnScreen(refb)
  //console.log("is viv", isVisibleBusiness);
  return (
    <div ref={refb} className={`${styles.businemsmain}`}

    >
      
      <div data-aos='slide-right' className={styles.ItolutioninnerContainer}>
        <h1>BUSINESS</h1>
        <div className={styles.Itolutioninner}>
          <div className={styles.ServiceRight}>
            <div className={styles.gridBUtton}>
              <button onClick={() => {setWhich('busWeb');setShowModel(true)}}>海外進出サポート</button>
            </div>
            <div className={styles.gridBUtton}>
              <button onClick={() => {setWhich('settings');setShowModel(true)}}>事業開発</button>
            </div>
            <div className={styles.gridBUtton}>
              <button onClick={() => {setWhich('busPen');setShowModel(true)}}>貿易サポート</button>
            </div>
            <div className={styles.gridBUtton}>
              <button>and more.</button>
            </div>
          </div>
          <div className={styles.ServiceLeft}>

            <div className={styles.puffincenter}>
              <p> 株式会社SHARVIL が提供することができるものは多岐にわたります。</p>

              <p>
                インターナショナルビジネスの長年の経験と実績、そして、世界中の拠点を活用し、海外進出のサポートや幅広い視点からの事業開発などのサポートが可能です。</p>


            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Business